"use client";

import Image from "next/image";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "./ScrollingTagsBanner.scss";

import "swiper/css";

const ScrollingTagsBanner = ({
  title,
  description,
  image,
  imageAlt = "Section background image",
  items = [],
  sectionClass = "",
}) => {
  return (
    <section className={`scrolling-tags-banner ${sectionClass}`}>
      <Container>
        <div className="tags-wrapper">
          <div className="image-container">
            <Image src={image} alt={imageAlt} fill className="bg-image" />

            <div className="image-overlay" />

            <div className="content-wrapper">
              <h2 className="section-title">{title}</h2>
              {description && (
                <p className="section-description">{description}</p>
              )}
            </div>

            <div className="bottom-swiper">
              <Swiper
                modules={[Autoplay]}
                loop={true}
                speed={3500}
                autoplay={{
                  delay: 0,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                allowTouchMove={true}
                grabCursor={true}
                slidesPerView="auto"
                spaceBetween={18}
                className="impact-swiper"
              >
                {items.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="impact-card">
                      <span className="dot" />
                      <span className="case-name">{item.title}</span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <Swiper
                modules={[Autoplay]}
                loop={true}
                speed={3500}
                autoplay={{
                  delay: 0,
                  reverseDirection: true,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                allowTouchMove={true}
                grabCursor={true}
                slidesPerView="auto"
                spaceBetween={18}
                className="impact-swiper second-swiper"
              >
                {items.map((item, index) => (
                  <SwiperSlide key={`second-${index}`}>
                    <div className="impact-card">
                      <span className="dot" />
                      <span className="case-name">{item.title}</span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ScrollingTagsBanner;
